import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { hide as hideModal } from '../../state-management/actions/modal';
import Modal from '../../components/Modal/Modal';
import HTMLContent from '../../components/HTMLContent/HTMLContent';
import Button from '../../components/Button/Button';


class ConfirmationModal extends React.Component {
    constructor(props) {
        super(props);

        this.handleConfirm = this.handleConfirm.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    handleConfirm() {
        this.props.hideModal();
        this.props.onConfirm();
    }

    handleCancel() {
        this.props.hideModal();
        this.props.onCancel();
    }

    render() {
        const {
            title,
            content,
            closeButtonText,
        } = this.props;
        return (
            <Modal
                className="modal--form"
                isOpen
            >
                <article>
                    <Modal.Title>{title}</Modal.Title>
                    <Modal.Content>
                        <HTMLContent
                            content={content}
                        />
                        <p>
                            For all questions, answer honestly with your first impulse. There are no "right" or "wrong" answers.
                            Do not try to out-think the questions or make yourself appear different than how you truly are.
                        </p>
                        <p>
                            <strong>  Most/Least: </strong>Respond in the way you think most people act or why people do things.
                            For each question, select the one response in each group of three that you believe to be most true.
                            Then select the one response of the remaining two that you believe to be least true.
                            These questions require that you select one answer in the<strong> MOST</strong> column and one answer in the<strong> LEAST</strong> column;
                            one response will be left blank for each question.
                        </p>
                        <p>
                            <strong>True/False:</strong> If you agree with the statement, or if it seems true or mostly true to you, click <strong>"True".</strong>
                            If you disagree with the statement, or if it seems false or mostly false to you, click <strong>"False".</strong>
                        </p>
                    </Modal.Content>
                    {closeButtonText &&
                        <Modal.Controls>
                            <Button
                                appearance="danger"
                                onClick={this.handleCancel}
                            >
                                {closeButtonText}
                            </Button>
                        </Modal.Controls>
                    }
                </article>
            </Modal>
        );
    }
}

ConfirmationModal.propTypes = {
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func.isRequired,
    title: PropTypes.string,
    content: PropTypes.string.isRequired,
    hideModal: PropTypes.func,
    closeButtonText: PropTypes.string,
};

ConfirmationModal.defaultProps = {
    hideModal: () => { },
    onCancel: () => { },
    closeButtonText: 'Close',
    title: 'Questions Instructions',
};

const mapDispatchToProps = dispatch => ({
    hideModal: () => dispatch(hideModal()),
});

export default connect(null, mapDispatchToProps)(ConfirmationModal);
